import loadable from '@loadable/component';

export const namespace = 'canalplus.block.selfcare.welcome';
export const Component = loadable(
  () => import('./containers/WelcomeContainer')
);
export { default as propsFormatter } from './propsFormatter';
